import { Image } from '@ui/Image';

import s from './ProductDetailsPromoActionInfo.sss';

interface Props {
  title: string,
  description?: string | null,
  iconUrl?: string | null,
}

export const ProductDetailsPromoActionInfo: React.FC<Props> = ({
  title,
  description,
  iconUrl,
}) => (
  <div className={s.root}>
    {iconUrl && (
      <Image
        className={s.image}
        src={iconUrl}
        width="24"
        height="24"
        alt="Icon"
      />
    )}
    <p className={s.caption}>
      {`${title} ${description}`}
    </p>
  </div>
);
